import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonComponent } from './button.component';
import { RouterModule } from '@angular/router';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { UtilitiesModule } from '../utilities/utilities.module';

@NgModule({
  declarations: [ButtonComponent],
  imports: [
    CommonModule,
    RouterModule,
    BrowserAnimationsModule,
    UtilitiesModule
  ],
  exports: [ButtonComponent]
})
export class ButtonModule { }
